import { useMemo } from 'react';
import { format } from 'date-fns';

import { FormProvider } from '@/context/FormProvider';

import { type BatchCallFormValues, batchCallSchema } from '@/schemas/batch-call.schema';

type Props = {
  children: React.ReactNode;
  onSubmit: (values: BatchCallFormValues) => void;
};

export const BatchCallFormProvider = ({ children, onSubmit }: Props) => {
  // Memoize so the reference stays stable across re-renders (e.g. after a
  // server-side validation error). Without this, enableReinitialize in
  // FormProvider would reset the form — clearing uploaded recipients — every
  // time the parent re-renders.
  const initialValues = useMemo<BatchCallFormValues>(() => {
    const now = new Date();
    return {
      batchName: '',
      agentId: '',
      recipients: [],
      scheduledDate: format(now, 'yyyy-MM-dd'),
      scheduledTime: format(now, 'HH:mm'),
      scheduledTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      isRecurring: false,
      recurringFrequency: 'day',
      recurringDaysOfWeek: [],
    };
  }, []);

  return (
    <FormProvider
      initialValues={initialValues}
      validationSchema={batchCallSchema}
      onSubmit={onSubmit}
    >
      {children}
    </FormProvider>
  );
};
